import React from "react";
import { FiRotateCcw } from "react-icons/fi";


export default function CatalogFilters({
  categories,
  brands,
  filters,
  onFilterChange,
  onClear,
}) {
  return (
    <div className="store-filter-bar">
      <label className="store-field store-field-inline store-filter-cell">
        <span>Kategoriya</span>
        <select value={filters.category} onChange={(event) => onFilterChange("category", event.target.value)}>
          <option value="">Barchasi</option>
          {categories.map((category) => (
            <option key={category.id} value={category.slug}>
              {category.name}
            </option>
          ))}
        </select>
      </label>

      <label className="store-field store-field-inline store-filter-cell">
        <span>Muallif</span>
        <select value={filters.brand} onChange={(event) => onFilterChange("brand", event.target.value)}>
          <option value="">Barchasi</option>
          {brands.map((brand) => (
            <option key={brand.id} value={brand.slug}>
              {brand.name}
            </option>
          ))}
        </select>
      </label>

      <label className="store-field store-field-inline store-filter-cell">
        <span>Saralash</span>
        <select value={filters.sort} onChange={(event) => onFilterChange("sort", event.target.value)}>
          <option value="">Yangi mahsulotlar</option>
          <option value="newest">Yangi</option>
          <option value="bestsellers">Eng ko'p sotilgan</option>
          <option value="price_asc">Narx: arzonidan</option>
          <option value="price_desc">Narx: qimmatidan</option>
          <option value="name">Nom bo'yicha</option>
        </select>
      </label>

      <button
        aria-label="Filterni tozalash"
        className="store-outline-button store-filter-reset"
        onClick={onClear}
        title="Filterni tozalash"
        type="button"
      >
        <FiRotateCcw aria-hidden="true" className="store-filter-reset-icon" />
        <span className="store-filter-reset-label">Tozalash</span>
      </button>
    </div>
  );
}
